import { render } from "./example.vue?vue&type=template&id=6ad60836&scoped=true&ts=true"
import script from "./example.vue?vue&type=script&lang=ts"
export * from "./example.vue?vue&type=script&lang=ts"

import "./example.vue?vue&type=style&index=0&id=6ad60836&lang=less&scoped=true"

import exportComponent from "/data/gitlab/pay.klicklpay.com/KlicklPaymentPage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad60836"]])

export default __exports__